import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import walkthroughIds from '../../../walkthroughIds';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import NameField from '@/components/forms/new/formikFormFields/NameField';

const PlatformVendorID = ({ darkMode, errors, touched, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.name && touched.name}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Vendor ID
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        System-generatred vendor identifier.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NameField}
                            id="vendorID"
                            name="vendorID"
                            placeholder="System-generated vendor ID"
                            readOnly={true}
                            isDisabled={true}
                            walkthroughid={
                                walkthroughIds.serviceProfiles
                                    ?.ufPlatformVendorIDInput
                            }
                            error={errors.vendorID}
                            {...props}
                        />
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="System-generated vendor identifier."
                        ariaLabel="platform-vendorID-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PlatformVendorID;
